import { FunctionComponent } from "react";

import Select from "rivals/components/shared/Form/Select";
import { SelectOption } from "rivals/components/shared/Form/Select/types";
import styles from "./index.module.scss";
import { OwnProps } from "./types";

const generateOptions = (availableYears: number[]): SelectOption<string>[] => {
  return availableYears.map(year => ({
    name: year.toString(),
    value: year.toString()
  }));
};

const YearsDropdown: FunctionComponent<OwnProps> = ({
  ariaLabel,
  availableYears,
  disabled = false,
  year,
  onSelect,
  philter = ""
}) => {
  if (!availableYears.length) {
    return null;
  }
  const options = generateOptions(availableYears);
  return (
    <div className={styles.selectWrapper}>
      <Select
        ariaLabel={ariaLabel}
        data={philter}
        disabled={disabled}
        onChange={onSelect}
        options={options}
        value={year.toString()}
      />
    </div>
  );
};

export default YearsDropdown;
